import {
  isRouteErrorResponse,
  Link,
  useRouteError,
} from 'react-router';

function getRouteErrorMessage(error: unknown) {
  if (isRouteErrorResponse(error)) {
    return `The route returned HTTP ${error.status}.`;
  }

  return 'An unexpected routing error prevented this workspace from loading.';
}

export function RouteErrorPage({ returnTo = '/' }: { returnTo?: string }) {
  const error = useRouteError();

  return (
    <main className="fatal-error" role="alert" aria-labelledby="route-error-title">
      <div className="fatal-error__panel">
        <p className="eyebrow">Navigation error</p>
        <h1 id="route-error-title">This workspace could not be loaded</h1>
        <p>{getRouteErrorMessage(error)}</p>
        <Link className="button button--primary" to={returnTo}>
          Return home
        </Link>
      </div>
    </main>
  );
}
